<template>
<v-data-table no-data-text="اطلاعاتی موجود نیست" :headers="headers" :items="data.permissions" disable-pagination :hide-default-footer="true" fixed-header item-key="_id" dense>
  <template v-slot:[`item.values`]="{ item }">
      <v-row>
        <v-col cols="12" sm="2" v-if="item.system.includes('show')">
          <v-checkbox v-if="item.name === 'exit'" disabled label="نمایش" color="primary" v-model="item.values" value="show"></v-checkbox>
          <v-checkbox v-if="item.name !== 'exit'" label="نمایش" color="primary" v-model="item.values" value="show"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="2" v-if="item.system.includes('add')">
          <v-checkbox label="افزودن" color="success" v-model="item.values" value="add"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="2" v-if="item.system.includes('edit')">
          <v-checkbox label="ویرایش" color="warning" v-model="item.values" value="edit"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="2" v-if="item.system.includes('remove')">
          <v-checkbox label="حذف" color="error" v-model="item.values" value="remove"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="2" v-if="item.system.includes('print')">
          <v-checkbox label="چاپ" color="info" v-model="item.values" value="print"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="2" v-if="item.system.includes('telegram')">
          <v-checkbox label="تلگرام" color="indigo" v-model="item.values" value="telegram"></v-checkbox>
        </v-col>
      </v-row>
    </template>
</v-data-table>
</template>
<script>
export default {
  name: "table-list",
  props: ['loading', 'headers', 'data', 'permissions'],
};
</script>

<style lang="scss">
table,
td {
    border: 2px solid lightgray;
    border-collapse: separate;
    font-size: 20px !important;
    // color: blue;
}
th {
    border: 3px solid lightgray;
    border-collapse: inherit;
    font-size: 20px !important;
    background-color: #546E7A !important;
    color: whitesmoke !important;
    // text-align: center;
}
table tr:nth-child(odd) {
    background-color: #fff;
}
table tr:nth-child(even) {
    background-color: #eee;
}
</style>
